import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import Header from '../pages/Header/Header';
import resalatProfile from '../ass/resalat-profile.png'
import Footer from '../pages/Header/Footer';

const Main = () => {
    return (
        <div className='text-gray-300'>
            <div className="drawer">
            <input id="my-drawer" type="checkbox" className="drawer-toggle" />
            <div className="drawer-content relative">
                <Header />
                <Outlet />
                <Footer />
            </div> 
            <div className="drawer-side ">
                <label htmlFor="my-drawer" className="drawer-overlay"></label>
                <div className="menu p-4 w-80 bg-[#202327] px-5 pt-10">
                    <div className="avatar flex items-center gap-3 ">
                        <div className="w-12">
                                <Link to='/'><img className='rounded-full' src={resalatProfile} alt="" /></Link>
                        </div>
                        <p className='text-gray-300 text-xl'>Resalat Islam</p>
                    </div>
                    <p className='mt-5 text-gray-300 text-xl'>I am a web devloper</p>
                    <hr className='w-full my-5' />
                    <ul className="menu w-72 bg-[#202327] text-gray-300">   
                        <li className='hover:text-white'><a href='#home' className='active:bg-black'>Home</a></li>
                        <li className='hover:text-white'><a href='#about' className='active:bg-black'>About</a></li>
                        <li className='hover:text-white'><a href='#portfolio' className='active:bg-black'>Portfolio</a></li>
                        <li className='hover:text-white'><a href='#contact' className='active:bg-black'>Contact</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    );
};

export default Main;